
      // Temporary workaround for @patternfly/react-topology using global
      window.global ||= window;
    